module.exports = __webpack_public_path__ + "static/media/johannes-elia.3c2a2f26.jpg";